import * as React from 'react';
import { icon } from '@harmony/enablers/react';
import { EventGroupType } from '../../Common/Constants/EventGroupType.Constants';
import { AppSessionContext } from '../../Services/Services.Primary/SessionContext/AppSessionContext';
import { getHarmonyScope } from '../../Services/Services.Secondary';
import TelemetryService from '../../Services/Services.Primary/Telemetry/TelemetryService';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { Metadata, SupportTopic } from './Models/SupportTopic';
import { Constants } from './Constants';
import { CategoryMap } from './CreateTicketFlowContainer';
import { TopicSearchData } from './Models/TopicSearchData';
import NextStepView from './NextStepView';
import { QueryStringParserService } from './Services/QueryStringParserService';
import SupportTopicSearch from './SupportTopicSearch';
import TopTopicsView from './TopTopicsView';
import { Helper } from './Utilities/Helper';

const Icon = getHarmonyScope().forReact(icon);
type QuickLinkIconName = 'documentation' | 'telemarketer' | 'health';

let Constant = Constants.getInstance();
let isEmptyOrSpaces = Helper.isEmptyOrSpaces;
let sessionContext = AppSessionContext.getInstance();
var resx = LocalizationService.getInstance();
let tracingService = TelemetryService.getInstance();

// Resource strings
let SearchTopicsSubheaderText = resx.getLocalizedResource('SearchTopicsSubheaderText');
let ProvideShortSummarySearchSubTitle_text = resx.getLocalizedResource('ProvideShortSummarySearchSubTitle_text');
let SearchTopicsHeaderText = resx.getLocalizedResource('SearchTopicsHeaderText');
let SupportTopicsNotAvailable_text = resx.getLocalizedResource('SupportTopicsNotAvailable_text');
let FilterByProgram = resx.getLocalizedResource('FilterByProgram');
let Workspace_text = resx.getLocalizedResource('Workspace_Text');
let AllPrograms = resx.getLocalizedResource('AllPrograms');
let L1Category_text = resx.getLocalizedResource('L1Category_text');
let L2Category_text = resx.getLocalizedResource('L2Category_text');
let L3Category_text = resx.getLocalizedResource('L3Category_text');
let NextStep_text = resx.getLocalizedResource('NextStep_text');
let ShowFilters_text = resx.getLocalizedResource('ShowFiltersText');
let HideFilters_text = resx.getLocalizedResource('HideFiltersText');
let HideTopics_text = resx.getLocalizedResource('HideTopics_text');
let BrowseTopics_text = resx.getLocalizedResource('BrowseTopics_text');
let L15category_text = resx.getLocalizedResource('L15category_text');
let SelectAnOption_text = resx.getLocalizedResource('SelectAnOption_text');
let SupportTopicsLoading_text = resx.getLocalizedResource('SupportTopicsLoading_text');
let TopSupportTopics_text = resx.getLocalizedResource('TopSupportTopics_text');
let PCHowTo_text = resx.getLocalizedResource('PCHowTo_text');
let PCapiDocs_text = resx.getLocalizedResource('PCapiDocs_text');
let CompareSupportOfferings_text = resx.getLocalizedResource('CompareSupportOfferings_text');
let PartnerCenterServiceHealth_text = resx.getLocalizedResource('PartnerCenterServiceHealth_text');
let ViewDocs_text = resx.getLocalizedResource('ViewDocs_text');
let ViewApiDocs_text = resx.getLocalizedResource('ViewApiDocs_text');
let ViewLevels_text = resx.getLocalizedResource('ViewLevels_text');
let ViewStatus_text = resx.getLocalizedResource('ViewStatus_text');
let GetStarted_text = resx.getLocalizedResource('GetStarted_text');
let SupportTopicsEmptyLoggingErrorMessage = 'Support topics is empty, please investigate!';
let ReviewSolution_text = resx.getLocalizedResource('ReviewSolution_text');

interface ITopicsViewProps {
  selectTopic: (
    supportTopic: SupportTopic,
    label: string,
    verbatim?: string | undefined,
    selectedRecommendedResult?: boolean,
    fromSearchResult?: boolean
  ) => void;
  setSolutionState: (supportTopic: SupportTopic) => void;
  supportTopicsTree: SupportTopic[] | null;
  filteredTopicsTree: SupportTopic[];
  selectedCategoryOrWorkspace: string;
  supportTopicsCategory2: string;
  setSupportTopicsWorkspace: (workspaceId: string) => void;
  setSupportTopicsCategory: (programId: string) => void;
  setSupportTopicsCategory2: (programId: string) => void;
  reviewSolutionText: string;
  flatTopicTree: TopicSearchData[];
  isSupportPublicRoute: boolean;
  category1To2map: CategoryMap;
  clearSearch: () => void;
  topicCategoriesOrWorkspaces: string[];
  topicSearchAttemptCount: number;
  topicDropdownActionCount: number;
  incrementTopicSearchAttemptCount: () => void;
  incrementTopicDropdownActionCount: () => void;
  topSupportTopicsList: [SupportTopic, string][];
  verbatim: string;
  updateVerbatim: (verbatim: string) => void;
  workspaceView: boolean;
  workspaceDropdownEnabled: boolean;
  includeUnauthTopics: boolean;
  otherWorkspaces: { [key: string]: string };
  productFamilyId: string;
  workspaceToProductMapping: Map<string, string>;
  agentTopics: string[];
}
interface ITopicsViewState {
  subTopics: SupportTopic[];
  parentTopic: SupportTopic | null;
  leafTopic: SupportTopic | null;
  showFilters: boolean;
  browseTopicsText: string;
  setSearchBoxText: string;
  shouldSetSearchBox: boolean;
}

let userProgramList: string[] = new Array<string>();
// if (
//   sessionContext.PartnerAccountInfo &&
//   sessionContext.PartnerAccountInfo.enrolledPrograms &&
//   sessionContext.PartnerAccountInfo.enrolledPrograms.length > 0
// ) {
//   for (let program of sessionContext.PartnerAccountInfo.enrolledPrograms) {
//     userProgramList.push(program);
//   }
// }

export default class TopicsContainer extends React.Component<ITopicsViewProps, ITopicsViewState> {
  constructor(props: ITopicsViewProps) {
    super(props);
    this.state = {
      subTopics: [],
      parentTopic: null,
      leafTopic: null,
      showFilters: false,
      browseTopicsText: BrowseTopics_text,
      setSearchBoxText: '',
      shouldSetSearchBox: false,
    };
    if (!this.props.selectedCategoryOrWorkspace) {
      let queryParams = QueryStringParserService.getQueryParameters(window.location.search);

      // set programId to the program in query parameter if user is enrolled in the program.
      if (queryParams['category']) {
        let programId = queryParams['category'];
        this.props.setSupportTopicsCategory(programId);
      }
    }
  }

  private onUnload = () => {
    let eventName = Constant.actionTypes.exitFromSearch;

    tracingService.traceEvent(eventName, {
      TopicSearchAttemptCount: this.props.topicSearchAttemptCount.toString(),
      TopicDropdownActionCount: this.props.topicDropdownActionCount.toString(),
    });
  };

  componentDidMount() {
    window.addEventListener('beforeunload', this.onUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.onUnload);
  }

  private setSolutionStateFromTopicSelection = () => {
    const topic = this.state.leafTopic ? this.state.leafTopic : this.state.parentTopic ? this.state.parentTopic : null;
    this.setSolutionState(topic);
  };

  private setSolutionState = (topic: SupportTopic | null) => {
    if (topic) {
      const eventName = Constant.actionTypes.reviewSolution;

      tracingService.traceEvent(
        eventName,
        { supportTopicId: topic.id.toString(), supportTopicName: topic.name },
        EventGroupType.userInteraction
      );
      this.props.setSolutionState(topic);
    }
  };

  private setSolutionStateFromTopTopicsList = (supportTopicPair: [SupportTopic, string]) => {
    this.props.selectTopic(supportTopicPair[0], supportTopicPair[1], '', false, false);
    const topic = supportTopicPair[0];
    const eventName = Constant.actionTypes.topTopicClicked;
    tracingService.traceEvent(eventName, { supportTopicId: topic.id.toString(), supportTopicName: topic.name });
    this.setSolutionState(topic);
  };

  public selectSearchTopic = (
    selectedSearchTopic: TopicSearchData,
    verbatim: string = '',
    selectedRecommendedResult: boolean = false
  ) => {
    this.setState({
      parentTopic: selectedSearchTopic.L2,
      leafTopic: selectedSearchTopic.L3 ? selectedSearchTopic.L3 : null,
    });

    let subTopics = selectedSearchTopic.L2.subtopics;
    this.setState({ subTopics: subTopics && subTopics.length > 0 ? subTopics : [] });
    let supportTopic = selectedSearchTopic.L3 ? selectedSearchTopic.L3 : selectedSearchTopic.L2;

    this.props.incrementTopicDropdownActionCount();

    this.props.selectTopic(supportTopic, selectedSearchTopic.label, verbatim, selectedRecommendedResult);

    if (this.props.workspaceDropdownEnabled) {
      // Check if workspaceName is empty and is not a agent wayfinderModelId -> set the L2 topic id
      const L2WayfinderModelIds = selectedSearchTopic.L2.metadata.wayfinderModelId;
      if (
        selectedSearchTopic.workspaceName === '' &&
        Object.keys(Constant.WayfinderModelIds.AgentFlowIds).indexOf(L2WayfinderModelIds[0]) === -1
      ) {
        this.props.setSupportTopicsWorkspace(selectedSearchTopic.L2.id);
      } else {
        this.props.setSupportTopicsWorkspace(selectedSearchTopic.workspaceId);
      }
    } else {
      this.props.setSupportTopicsCategory(selectedSearchTopic.category);
      this.props.setSupportTopicsCategory2(
        this.props.category1To2map[selectedSearchTopic.category as keyof CategoryMap].length > 0 &&
          !selectedSearchTopic.category2
          ? Constant.ProgramId.OtherProgram
          : selectedSearchTopic.category2
      );
    }
    this.setState({ setSearchBoxText: '', shouldSetSearchBox: false });
  };

  public clearSearch = () => {
    this.setState({ parentTopic: null, leafTopic: null, subTopics: [], shouldSetSearchBox: false });
    this.props.clearSearch();
  };

  // setting trackTrace to avoid multiple logging of custom event for onchange and onblur
  private selectParentTopic = (event: React.FormEvent<EventTarget>) => {
    let target = event.target as HTMLInputElement;
    this.props.incrementTopicDropdownActionCount();

    if (this.props.workspaceDropdownEnabled) {
      const supportTopic = this.props.filteredTopicsTree.find(t => t.id === target.value);

      const searchBoxText = supportTopic?.name;
      this.setState({
        parentTopic: supportTopic ?? null,
        leafTopic: null,
        setSearchBoxText: searchBoxText ?? '',
        shouldSetSearchBox: true,
      });

      // If Other Portals topic, selected workspace will be L2 topic ID. In this case, return all its subtopics
      const subTopics =
        this.props.selectedCategoryOrWorkspace === supportTopic?.id
          ? supportTopic.subtopics ?? []
          : supportTopic?.subtopics?.filter(
              subtopic =>
                subtopic &&
                subtopic.metadata &&
                ((subtopic.metadata[Constant.Workspace.WorkspaceProperty as keyof Metadata] ?? []).includes(
                  this.props.selectedCategoryOrWorkspace
                ) ||
                  (subtopic.metadata[Constant.Workspace.WorkspaceCategoryProperty as keyof Metadata] ?? []).includes(
                    this.props.selectedCategoryOrWorkspace
                  ))
            );

      if (subTopics && subTopics.length > 0) {
        let eventName = Constant.actionTypes.supportParentTopic;

        tracingService.traceEvent(
          eventName,
          { supportTopicId: supportTopic?.id.toString(), supportTopicName: supportTopic?.name },
          EventGroupType.userInteraction
        );

        this.setState({ subTopics: subTopics });
      } else {
        let eventName = Constant.actionTypes.selectSupportTopicFromCategories;

        tracingService.traceEvent(
          eventName,
          { supportTopicId: supportTopic?.id.toString(), supportTopicName: supportTopic?.name },
          EventGroupType.userInteraction
        );

        if (supportTopic !== undefined) {
          this.props.selectTopic(supportTopic, searchBoxText ?? '', undefined, false, false);
        }

        this.setState({ subTopics: [] });
      }
    } else {
      let categoryL15Label =
        this.props.supportTopicsCategory2 && this.props.supportTopicsCategory2 != Constant.ProgramId.OtherProgram
          ? Helper.getProgramTagFromId(this.props.supportTopicsCategory2) + ' > '
          : '';
      let L15_categories = new Set([Constant.ProgramId.OemProgramId, Constant.ProgramId.SamProgramId]);
      if (this.props.supportTopicsTree) {
        for (let supportTopic of this.props.supportTopicsTree) {
          if (supportTopic.id.toString() === target.value) {
            if (
              supportTopic.metadata &&
              supportTopic.metadata.categoriesLevel2 &&
              supportTopic.metadata.categoriesLevel2.length > 0
            ) {
              if (Helper.isEmptyOrSpaces(categoryL15Label)) {
                supportTopic.metadata.categoriesLevel2.forEach(categoryl2 => {
                  if (L15_categories.has(categoryl2)) {
                    categoryL15Label = Helper.getProgramTagFromId(categoryl2) + ' > ';
                    this.props.setSupportTopicsCategory2(categoryl2);
                  }
                });
              }
            }

            let topicCategory = '';

            if (
              this.props.selectedCategoryOrWorkspace &&
              supportTopic?.categories?.indexOf(this.props.selectedCategoryOrWorkspace) != -1
            ) {
              topicCategory = Helper.getProgramTagFromId(this.props.selectedCategoryOrWorkspace) + ' > ';
            }

            let searchBoxText = topicCategory + categoryL15Label + supportTopic.name;
            this.setState({
              parentTopic: supportTopic,
              leafTopic: null,
              setSearchBoxText: searchBoxText,
              shouldSetSearchBox: true,
            });
            let subTopics = new Array<SupportTopic>();

            if (this.props.selectedCategoryOrWorkspace === Constant.ProgramId.AllProgramsId) {
              subTopics = supportTopic.subtopics ?? [];
            } else {
              for (let topic of supportTopic.subtopics ?? []) {
                //each subtopic should only have one category, hence the choosing the first item
                if (
                  topic &&
                  topic.categories &&
                  topic.categories[0].toString() === this.props.selectedCategoryOrWorkspace
                ) {
                  subTopics.push(topic);
                }
              }
            }

            if (subTopics && subTopics.length > 0) {
              let eventName = Constant.actionTypes.supportParentTopic;

              tracingService.traceEvent(
                eventName,
                { supportTopicId: supportTopic.id.toString(), supportTopicName: supportTopic.name },
                EventGroupType.userInteraction
              );

              this.setState({ subTopics: subTopics });
            } else {
              let eventName = Constant.actionTypes.selectSupportTopicFromCategories;

              tracingService.traceEvent(
                eventName,
                { supportTopicId: supportTopic.id.toString(), supportTopicName: supportTopic.name },
                EventGroupType.userInteraction
              );

              this.props.selectTopic(supportTopic, searchBoxText, undefined, false, false);
              this.setState({ subTopics: [] });
            }
          }
        }
      }
    }
  };

  // setting trackTrace to avoid multiple logging of custom event for onchange and onblur
  private selectLeafTopic = (event: React.FormEvent<EventTarget>) => {
    let target = event.target as HTMLInputElement;
    this.props.incrementTopicDropdownActionCount();

    const subTopic = this.state.subTopics.find(st => st.id === target.value);

    const searchBoxText = this.props.workspaceDropdownEnabled
      ? this.state.parentTopic?.name + ' > ' + subTopic?.name
      : Helper.getProgramTagFromId(subTopic && subTopic.categories ? subTopic.categories[0] : '') +
        ' > ' +
        this.getCategoryL15Label() +
        this.state.parentTopic?.name +
        ' > ' +
        subTopic?.name;

    const eventName = Constant.actionTypes.selectSupportTopicFromCategories;

    tracingService.traceEvent(
      eventName,
      { supportTopicId: subTopic?.id.toString(), supportTopicName: subTopic?.name },
      EventGroupType.userInteraction
    );

    if (subTopic !== undefined) {
      this.props.selectTopic(subTopic, searchBoxText, undefined, false, false);
      this.setState({
        leafTopic: subTopic,
        setSearchBoxText: searchBoxText,
        shouldSetSearchBox: true,
      });
    }
  };

  private selectCategoryOrWorkspace = (event: React.FormEvent<EventTarget>) => {
    const target = event.target as HTMLInputElement;
    this.props.incrementTopicDropdownActionCount();
    const categoryOrWorkspaceId = target.value;
    const eventName = Constant.actionTypes.supportTopicFilter;
    tracingService.traceEvent(eventName, { selectedCategoryOrWorkspace: categoryOrWorkspaceId });
    const searchBoxText = this.props.workspaceDropdownEnabled
      ? ''
      : Helper.getTagFromId(categoryOrWorkspaceId, this.props.workspaceDropdownEnabled);

    this.setState({
      parentTopic: null,
      leafTopic: null,
      subTopics: [],
      setSearchBoxText: searchBoxText,
      shouldSetSearchBox: true,
    });

    if (this.props.workspaceDropdownEnabled) {
      this.props.setSupportTopicsWorkspace(categoryOrWorkspaceId);
    } else {
      this.props.setSupportTopicsCategory(categoryOrWorkspaceId);
    }
  };

  private selectProgram2 = (event: React.FormEvent<EventTarget>) => {
    let target = event.target as HTMLInputElement;
    this.props.incrementTopicDropdownActionCount();
    let program = target.value;
    let eventName = Constant.actionTypes.supportTopicFilter;
    tracingService.traceEvent(eventName, { program: program });
    this.setState({
      parentTopic: null,
      leafTopic: null,
      subTopics: [],
      setSearchBoxText:
        Helper.getProgramTagFromId(this.props.selectedCategoryOrWorkspace) +
        (program && program != Constant.ProgramId.OtherProgram ? ' > ' + Helper.getProgramTagFromId(program) : ''),
      shouldSetSearchBox: true,
    });
    this.props.setSupportTopicsCategory2(program);
  };

  private getCategoryL15Label = () =>
    this.props.supportTopicsCategory2 && this.props.supportTopicsCategory2 != Constant.ProgramId.OtherProgram
      ? Helper.getProgramTagFromId(this.props.supportTopicsCategory2) + ' > '
      : '';

  private SetBrowseTopics = (newState: boolean) => {
    this.setState({ showFilters: newState, browseTopicsText: newState ? HideTopics_text : BrowseTopics_text });
  };

  private isLeafTopicSet = (): boolean => {
    return this.state.leafTopic
      ? true
      : this.state.parentTopic && (!this.state.parentTopic.subtopics || this.state.parentTopic.subtopics.length < 1)
      ? true
      : false;
  };

  private displayL2Dropdown = (): boolean => {
    if (this.props.workspaceDropdownEnabled) {
      return (
        this.props.filteredTopicsTree.length > 0 && !Helper.isEmptyOrSpaces(this.props.selectedCategoryOrWorkspace)
      );
    } else {
      //if a cat2 topic has been set, show L2
      if (this.props.supportTopicsCategory2) {
        return true;
      }

      //corresponds to the default "all programs category"
      if (
        this.props.selectedCategoryOrWorkspace &&
        this.props.category1To2map[this.props.selectedCategoryOrWorkspace as keyof CategoryMap].length < 1
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  private hasCategory2Topics = (topic: SupportTopic): boolean => {
    if (topic && topic.metadata && topic.metadata.categoriesLevel2 && topic.metadata.categoriesLevel2.length > 0) {
      if (topic.metadata.categoriesLevel2.length < 2 && Helper.isEmptyOrSpaces(topic.metadata.categoriesLevel2[0])) {
        return false;
      }
      return true;
    }

    return false;
  };

  private goToViewDocLink = () => {
    window.open('https://docs.microsoft.com/partner-center/', '_blank');
  };

  private goToViewAPIDocLink = () => {
    window.open('https://docs.microsoft.com/partner-center/develop/', '_blank');
  };

  private goToViewLevelLink = () => {
    window.open('https://partner.microsoft.com/support/partnersupport', '_blank');
  };

  private goToViewServiceHealthLink = () => {
    window.open('https://partner.microsoft.com/' + sessionContext.Locale + '/support/service-health-status', '_blank');
  };

  private getViewDocIconCircle = (iconName: QuickLinkIconName) => {
    const circleStyle = {
      backgroundColor: 'black',
      width: '30px',
      height: '30px',
      borderRadius: '24px',
      display: 'inline-block',
      verticalAlign: 'top',
    };
    return (
      <div style={circleStyle}>
        <div className="viewDocIcon">
          <Icon name={iconName} />
        </div>
      </div>
    );
  };

  private getDocDiv = (iconName: QuickLinkIconName, title: string, viewText: string, callBack: () => void) => {
    return (
      <div className="col-xs-24 docDivColView">
        <div className="cardView docDivView">
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
            {this.getViewDocIconCircle(iconName)}
            <div
              style={{
                fontSize: '14px',
                fontWeight: 'bold',
                marginBottom: '25px',
                marginLeft: '5px',
                marginTop: '6px',
                marginRight: '5px',
                display: 'inline-block',
              }}
            >
              {title}
            </div>
          </div>
          <div>
            <button
              data-toggle="tab"
              style={{ padding: '0px', textDecoration: 'none', outline: 0, border: 'none', textAlign: 'left' }}
              className="generalLink btn-link"
              onClick={callBack}
            >
              {viewText}
            </button>
          </div>
        </div>
      </div>
    );
  };

  private getNextStepDiv = () => {
    let continueDiv = (
      <button
        className="btn-primary"
        disabled={!this.isLeafTopicSet() || Helper.isEmptyOrSpaces(this.props.verbatim)}
        onClick={this.setSolutionStateFromTopicSelection}
      >
        {ReviewSolution_text + ' >'}
      </button>
    );
    return (
      <NextStepView
        ContinueDiv={continueDiv}
        marginTop={'24px'}
        marginBottom={'0'}
        padding={'0'}
        fontWeight={this.props.isSupportPublicRoute ? 'normal' : 'bold'}
      />
    );
  };

  private displaySearchTopicsHeaderText = () => {
    return (
      <div className="SearchTopicsHeaderText" style={{ marginBottom: '20px' }}>
        <div className="page-title-header-search-topics-page">
          <h2
            className="page-title remove-bottom-margin"
            style={{ fontSize: '18px', fontWeight: 800, lineHeight: '28px' }}
          >
            {SearchTopicsHeaderText}
          </h2>
        </div>
      </div>
    );
  };

  private displayCategoryOrWorkspaceLabel = () => {
    return this.props.workspaceDropdownEnabled ? Workspace_text : L1Category_text;
  };

  private getTopics = () => {
    if (this.props.workspaceDropdownEnabled) {
      return this.props.filteredTopicsTree.map((supportTopic: SupportTopic) => (
        <option value={supportTopic.id} title={supportTopic.name} data-toggle="tooltip">
          {supportTopic.name}
        </option>
      ));
    } else {
      let supportTopicsL2 = this.props.supportTopicsTree?.filter(
        (supportTopic: SupportTopic) =>
          this.props.selectedCategoryOrWorkspace === Constant.ProgramId.AllProgramsId ||
          (supportTopic.categories &&
            supportTopic.categories.indexOf(this.props.selectedCategoryOrWorkspace) !== -1 &&
            ((this.props.supportTopicsCategory2 &&
              this.props.supportTopicsCategory2.indexOf(Constant.ProgramId.OtherProgram) !== -1 &&
              supportTopic.metadata &&
              !supportTopic.metadata.categoriesLevel2) ||
              (!this.props.supportTopicsCategory2 && supportTopic.metadata && !this.hasCategory2Topics(supportTopic)) ||
              (this.props.supportTopicsCategory2 &&
                supportTopic.metadata &&
                supportTopic.metadata.categoriesLevel2 &&
                supportTopic.metadata.categoriesLevel2.length > 0 &&
                supportTopic.metadata.categoriesLevel2.indexOf(this.props.supportTopicsCategory2) !== -1))) ||
          (this.props.selectedCategoryOrWorkspace === Constant.ProgramId.GeneralProgramId &&
            (supportTopic.categories === null || supportTopic?.categories?.length === 0))
      );
      return supportTopicsL2?.map((supportTopic: SupportTopic) => (
        <option value={supportTopic.id} title={supportTopic.name} data-toggle="tooltip">
          {supportTopic.name}
        </option>
      ));
    }
  };

  public render() {
    let display = (
      <div>
        {(() => {
          if (this.props.supportTopicsTree == null || this.props.supportTopicsTree.length == 0) {
            if (Helper.refreshPage()) {
              return <span style={{ paddingLeft: '32px', paddingRight: '32px' }}>{SupportTopicsLoading_text}</span>;
            } else {
              tracingService.traceError(SupportTopicsEmptyLoggingErrorMessage);
              return (
                <span style={{ paddingLeft: '32px', paddingRight: '32px' }} className="errorMessage">
                  {SupportTopicsNotAvailable_text}
                </span>
              );
            }
          } else {
            const containerStyle = this.props.workspaceView ? {} : { margin: '0px 0px 24px 0px', padding: '0px 24px' };
            const containerClass = this.props.workspaceView ? 'col-xs-24 remove-all-padding' : 'col-xs-24';
            const filterButtonClass =
              this.props.workspaceDropdownEnabled &&
              (Helper.isEmptyOrSpaces(this.props.verbatim) ||
                Helper.isEmptyOrSpaces(this.props.selectedCategoryOrWorkspace))
                ? 'disabled'
                : '';
            const l2LabelStyle = this.props.workspaceDropdownEnabled
              ? { marginBottom: '15px', marginTop: '15px' }
              : { marginBottom: '15px' };

            return (
              <div className="row flexShrink0 margin0" style={{ paddingBottom: '24px', height: 'inherit' }}>
                <div className={containerClass} style={containerStyle}>
                  <div className="topicdropdowns cardView" style={{ padding: '24px', minWidth: '198px' }}>
                    {this.displaySearchTopicsHeaderText()}
                    <SupportTopicSearch
                      flatTopicTree={this.props.flatTopicTree}
                      selectedCategoryOrWorkspace={this.props.selectedCategoryOrWorkspace}
                      clearSearchCallback={this.clearSearch}
                      selectTopicCallback={this.selectSearchTopic}
                      setSearchBox={this.state.setSearchBoxText}
                      incrementTopicSearchAttemptCount={this.props.incrementTopicSearchAttemptCount}
                      shouldSetSearchFromParent={this.state.shouldSetSearchBox}
                      showFilters={this.SetBrowseTopics}
                      verbatim={this.props.verbatim}
                      updateVerbatim={this.props.updateVerbatim}
                      workspaceDropdownEnabled={this.props.workspaceDropdownEnabled}
                      selectWorkspaceCallback={this.selectCategoryOrWorkspace}
                      workspaces={this.props.topicCategoriesOrWorkspaces}
                      includeUnauthTopics={this.props.includeUnauthTopics}
                      otherWorkspaces={this.props.otherWorkspaces}
                      setWorkspaceCallback={
                        this.props.workspaceDropdownEnabled
                          ? this.props.setSupportTopicsWorkspace
                          : this.props.setSupportTopicsCategory
                      }
                      productFamilyId={this.props.productFamilyId}
                      workspaceToProductMapping={this.props.workspaceToProductMapping}
                      agentTopics={this.props.agentTopics}
                    />

                    <button
                      id="filtersButton"
                      className={filterButtonClass}
                      onClick={() => this.SetBrowseTopics(!this.state.showFilters)}
                    >
                      {this.state.browseTopicsText}
                    </button>
                    {this.state.showFilters && !this.props.workspaceDropdownEnabled && (
                      <div className="dropdown" style={{ marginBottom: '20px', width: '246px' }}>
                        <label style={{ marginBottom: '15px', marginTop: '15px' }}>
                          {this.displayCategoryOrWorkspaceLabel()}
                        </label>
                        <div className="combobox">
                          <select
                            className="form-control category-dropdown"
                            aria-label={this.displayCategoryOrWorkspaceLabel()}
                            onChange={e => this.selectCategoryOrWorkspace(e)}
                            value={this.props.selectedCategoryOrWorkspace || ''}
                          >
                            <option disabled={true} selected={true} value="">
                              {SelectAnOption_text}
                            </option>
                            {!this.props.workspaceDropdownEnabled && (
                              <option value={Constant.ProgramId.AllProgramsId}>{AllPrograms}</option>
                            )}
                            {this.props.topicCategoriesOrWorkspaces.map(categoryOrWorkspaceId => (
                              <option value={categoryOrWorkspaceId}>
                                {Helper.getTagFromId(categoryOrWorkspaceId, this.props.workspaceDropdownEnabled)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    {this.state.showFilters &&
                      !this.props.workspaceDropdownEnabled &&
                      this.props.selectedCategoryOrWorkspace &&
                      this.props.category1To2map[this.props.selectedCategoryOrWorkspace as keyof CategoryMap].length >
                        0 && (
                        <div className="dropdown" style={{ marginBottom: '20px', width: '246px' }}>
                          <p style={{ marginBottom: '15px', marginTop: '15px' }}>{L15category_text}</p>
                          <div className="combobox">
                            <select
                              className="form-control category-dropdown"
                              aria-label={L15category_text}
                              onChange={e => this.selectProgram2(e)}
                              value={this.props.supportTopicsCategory2 ? this.props.supportTopicsCategory2 : ''}
                            >
                              <option disabled={true} selected={true} value="">
                                {SelectAnOption_text}
                              </option>
                              {this.props.category1To2map[
                                this.props.selectedCategoryOrWorkspace as keyof CategoryMap
                              ].map(category2 => (
                                <option value={category2}>{Helper.getProgramTagFromId(category2)}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    {this.displayL2Dropdown() && this.state.showFilters && (
                      <div className="dropdown" style={{ marginBottom: '24px', width: '400px' }}>
                        <label style={l2LabelStyle}>{L2Category_text}</label>
                        <div className="combobox">
                          <select
                            className="form-control  category-dropdown"
                            aria-label={L2Category_text}
                            onChange={e => this.selectParentTopic(e)}
                            value={this.state.parentTopic && this.state.parentTopic.id ? this.state.parentTopic.id : ''}
                            title={this.state.parentTopic ? this.state.parentTopic.name : ''}
                            data-toggle="tooltip"
                          >
                            <option disabled={true} selected={true} value="">
                              {SelectAnOption_text}
                            </option>
                            {this.getTopics()}
                          </select>
                        </div>
                      </div>
                    )}
                    {this.state.subTopics && this.state.subTopics.length > 0 && this.state.showFilters && (
                      <div className="dropdown" style={{ marginBottom: '20px', width: '400px' }}>
                        <label style={{ marginBottom: '15px' }}>{L3Category_text}</label>
                        <div className="combobox">
                          <select
                            className="form-control category-dropdown"
                            aria-label={L3Category_text}
                            onChange={e => this.selectLeafTopic(e)}
                            value={this.state.leafTopic && this.state.leafTopic.id ? this.state.leafTopic.id : ''}
                            title={this.state.leafTopic ? this.state.leafTopic.name : ''}
                            data-toggle="tooltip"
                          >
                            <option disabled={true} selected={true} value="">
                              {SelectAnOption_text}
                            </option>
                            {this.state.subTopics.map((supportTopic: SupportTopic, index) => (
                              <option value={supportTopic.id} title={supportTopic.name} data-toggle="tooltip">
                                {supportTopic.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    {this.getNextStepDiv()}
                  </div>
                </div>
                {this.props.topSupportTopicsList &&
                  this.props.topSupportTopicsList.length > 0 &&
                  this.props.isSupportPublicRoute && (
                    <div className="col-xs-24" style={{ margin: '0px 0px 24px 0px', padding: '0px 24px' }}>
                      <div className="cardView" style={{ padding: '24px' }}>
                        <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '16px' }}>
                          {TopSupportTopics_text}
                        </div>
                        <TopTopicsView
                          topTopicsList={this.props.topSupportTopicsList}
                          topTopicSelection={this.setSolutionStateFromTopTopicsList}
                        />
                      </div>
                    </div>
                  )}
                {this.props.isSupportPublicRoute && (
                  <div className="col-xs-24" style={{ margin: 0, marginBottom: '24px', padding: '0px 24px' }}>
                    <div className="row">
                      {this.getDocDiv(
                        'documentation',
                        PCHowTo_text,
                        ViewDocs_text,
                        this.goToViewDocLink
                      )}
                      {this.getDocDiv(
                        'documentation',
                        PCapiDocs_text,
                        ViewApiDocs_text,
                        this.goToViewAPIDocLink
                      )}
                      {this.getDocDiv(
                        'telemarketer',
                        CompareSupportOfferings_text,
                        ViewLevels_text,
                        this.goToViewLevelLink
                      )}
                    </div>
                    <div className="row" style={{ paddingTop: '24px' }}>
                      {this.getDocDiv(
                        'health',
                        PartnerCenterServiceHealth_text,
                        ViewStatus_text,
                        this.goToViewServiceHealthLink
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          }
        })()}
      </div>
    );
    return display;
  }
}
